import React, { Component } from 'react';
import { connect } from 'react-redux';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, Label } from 'recharts';
import moment from 'moment';
import { AlertsActions } from '../../../../store';
import './InformationGraph.css';

interface Props {
  dataApiLocation: string;
  getInformationGraphData(dataApiLocation: string): Promise<any>;
}

interface State {
  data: DataType;
}

interface DataType {
  data_points: DataPointsType[];
}

interface DataPointsType {
  id: string;
  tag: string;
  name: string;
  unit: string;
  graph_data: {
    x: string;
    actual: number;
  }[];
}

const lineColorMapping = ['#bbbbbb', '#ee6677', '#66ccee', '#aa3377', '#ccbb44', '#4477aa', '#228833'];

export class InformationGraph extends Component<Props, State> {
  state = {
    data: {} as DataType,
  };

  async componentDidMount() {
    const { getInformationGraphData, dataApiLocation } = this.props;

    const data = await getInformationGraphData(dataApiLocation);

    this.setState((state) => ({
      ...state,
      data,
    }));
  }

  renderCustomTooltip = ({ payload, label, active }: any) => {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
      </div>
    );
  };

  renderContext = () => {
    const {
      data: { data_points },
    } = this.state;

    return (
      <div>
        {data_points.map((dataSet, i) => {
          const { graph_data, id, unit } = dataSet;

          const statusData = `${graph_data[graph_data.length - 1].actual} ${unit}`;
          const lineStyle = `line line${i}`;

          return (
            <div key={id} className="event-information__legend-item">
              <div className="equal-width">{id}</div>
              <div className="equal-width">
                <div className={lineStyle} />
              </div>
              <div className="equal-width">{statusData}</div>
            </div>
          );
        })}
      </div>
    );
  };

  render() {
    const { data } = this.state;

    if (!Object.keys(data).length) {
      return null;
    }

    const mobileWindowWidth = window.innerWidth < 599;
    const graphWidth = mobileWindowWidth ? window.innerWidth : window.innerWidth * 0.9;
    const graphHeight = mobileWindowWidth ? 250 : 400;

    return (
      <React.Fragment>
        <div className="event-information__graph-section">
          <div className="event-information__graph">
            <LineChart
              width={graphWidth}
              height={graphHeight}
              margin={mobileWindowWidth ? { right: 30 } : { top: 30, right: 30, left: 30, bottom: 30 }}
            >
              {data.data_points.map((dataSet, i) => {
                const { graph_data, tag } = dataSet;

                return (
                  <Line
                    type="monotone"
                    name={tag}
                    dataKey="actual"
                    data={graph_data}
                    stroke={lineColorMapping[i]}
                    dot={false}
                  />
                );
              })}
              <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
              <XAxis
                dataKey="x"
                allowDuplicatedCategory={false}
                interval={25}
                tickFormatter={(timeStr) => moment(timeStr).format('MMM D HH:mm')}
              >
                {mobileWindowWidth ? null : (
                  <Label value={'Time'} position="bottom" style={{ textAnchor: 'middle', fontSize: '16px' }} />
                )}
              </XAxis>
              <YAxis>
                {mobileWindowWidth ? null : (
                  <Label
                    value={'Value'}
                    position="left"
                    angle={-90}
                    style={{ textAnchor: 'middle', fontSize: '16px' }}
                  />
                )}
              </YAxis>
              <Tooltip
                wrapperStyle={{ textSize: '16px' }}
                itemStyle={{ textSize: '16px' }}
                // content={({ payload, label, active }: any) => {
                //   return (
                //     <div className="custom-tooltip">
                //       <p>{moment(label).format('Do hh:mm A')}</p>
                //     </div>
                //   );
                // }}
              />
            </LineChart>
          </div>
        </div>
        <div className="event-information__context-section">
          <div className="event-information__legend">
            <div className="event-information__legend-header">
              <div className="event-information__legend-title">Context</div>
            </div>
            <div className="event-information__column-names">
              <div className="equal-width">Name</div>
              <div className="equal-width">Color</div>
              <div className="equal-width">Status</div>
            </div>
            {this.renderContext()}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  getInformationGraphData: AlertsActions.getInformationGraphData,
};

export const ConnectedInformationGraph = connect(null, mapDispatchToProps)(InformationGraph);
